module.exports = __webpack_public_path__ + "img/ic_delete.2ab1db65.svg";